module.exports = __webpack_public_path__ + "static/media/affiliated_business.f44029b9.svg";